import Global from "./Global";
export default { Global: Global };
//# sourceMappingURL=index.js.map